/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import importDialogTemplate from './import-dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/* eslint-disable no-undef, angular/window-service, angular/document-service */

/*@ngInject*/
export default function ImportExport($mdDialog, $document, $q) {

    var service = {
        uploadFile: uploadFile,
        downloadFile: downloadFile
    };

    return service;

    function uploadFile($event, fileTypes, importTitle, importFileLabel) {
        var deferred = $q.defer();
        $mdDialog.show({
            controller: 'ImportDialogController',
            controllerAs: 'vm',
            templateUrl: importDialogTemplate,
            locals: {
                fileTypes: fileTypes,
                importTitle: importTitle,
                importFileLabel: importFileLabel
            },
            parent: angular.element($document[0].body),
            skipHide: true,
            fullscreen: true,
            targetEvent: $event,
            multiple: true
        }).then(function (importData) {
            deferred.resolve(importData);
        }, function () {
            deferred.reject();
        });
        return deferred.promise;
    }

    function downloadFile(data, filename, fileType) {
        if (!filename) {
            filename = 'download';
        }
        filename += '.' + fileType.extension;
        var blob = new Blob([data], {type: fileType.mimeType});
        // FOR IE:
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var e = document.createEvent('MouseEvents'),
                a = document.createElement('a');
            a.download = filename;
            a.href = window.URL.createObjectURL(blob);
            a.dataset.downloadurl = [fileType.mimeType, a.download, a.href].join(':');
            e.initEvent('click', true, false, window,
                0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
        }
    }

}

/* eslint-enable no-undef, angular/window-service, angular/document-service */


// WEBPACK FOOTER //
// ./src/app/import-export/import-export.service.js